import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class DashboardModel {
	private date = new BehaviorSubject<string>('');

	date$ = this.date.asObservable();

	setDate(date: string) {
		this.date.next(date);
	}
}
